import { CheckCircle2, AlertTriangle, XCircle, ShieldCheck } from "lucide-react";
import { useTranslation } from "react-i18next";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";

function Icon({ status }) {
  if (status === "pass") return <CheckCircle2 className="h-3.5 w-3.5 text-success" />;
  if (status === "warn") return <AlertTriangle className="h-3.5 w-3.5 text-warning" />;
  return <XCircle className="h-3.5 w-3.5 text-destructive" />;
}

export function TrustFlags({ checks = [] }) {
  const { t } = useTranslation();
  if (!checks.length) return null;
  return (
    <div data-testid="trust-flags">
      <div className="mb-3 flex items-center gap-2">
        <ShieldCheck className="h-4 w-4 text-ikb" />
        <span className="text-xs font-semibold uppercase tracking-overline text-muted-foreground">
          {t("trust.layer")}
        </span>
      </div>
      <TooltipProvider delayDuration={100}>
        <div className="flex flex-wrap gap-2">
          {checks.map((c) => (
            <Tooltip key={c.module}>
              <TooltipTrigger asChild>
                <div
                  className="flex items-center gap-1.5 rounded-full border border-border bg-card px-2.5 py-1"
                  data-testid={`trust-${c.module}`}
                >
                  <Icon status={c.status} />
                  <span className="text-xs font-medium">{t(`trust.${c.module}`, c.module)}</span>
                </div>
              </TooltipTrigger>
              <TooltipContent className="max-w-xs">
                <p className="text-xs">{c.detail}</p>
              </TooltipContent>
            </Tooltip>
          ))}
        </div>
      </TooltipProvider>
    </div>
  );
}
